var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRotateRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.3425,
    cy: 53.3425,
    r: 53.3425,
    fill: "#102437"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3199 30.5485C60.4136 29.68 57.2066 29.1121 53.6655 29.1121C37.6638 29.1121 24.7021 42.0737 24.7021 58.0754C24.7021 74.1105 37.6638 87.0722 53.6655 87.0722C69.6672 87.0722 82.6288 74.1105 82.6288 58.1088C82.6288 52.1625 80.8249 46.617 77.7515 42.0069",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4621 31.3502L57.8076 20.2593",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.463 31.3503L56.2051 39.5683",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateRight);
export default __webpack_public_path__ + "static/media/RotateRight.9d4060461961fd70c464468ec42e83b4.svg";
export { ForwardRef as ReactComponent };